import React, { useRef, useState } from "react";
import Checkbox from "../ui/Checkbox";
import imageupload from "../../assets/imageuploadicon.png";
import { FaClipboardList } from "react-icons/fa";

const VisaAssistance: React.FC = () => {
  const photoInputRef = useRef<HTMLInputElement>(null);
  const passportInputRef = useRef<HTMLInputElement>(null);

  const [agreed, setAgreed] = useState(false);

  return (
    <section className="max-w-screen-lg mx-auto py-8 px-4 font-sans">
      {/* Hero Cover */}
      <div className="relative w-full h-[420px] rounded-2xl overflow-hidden shadow-[0px_1.53px_8px_rgba(0,0,0,0.12)] mb-8">
        <img
          src="/assets/visacover.jpg"
          alt="Visa Assistance"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 flex flex-col justify-center px-10">
          <h2 className="text-white text-4xl font-sora font-bold leading-tight max-w-lg mb-6">
            With you at <br /> every step of <br /> your journey.
          </h2>
          {/* Right Buttons */}
          <div className="absolute right-10 top-1/2 -translate-y-1/2 flex flex-col gap-5 items-end">
            <button className="bg-gradient-to-b from-[#0B2F9F] to-[#3F6AEF] text-white px-6 py-5 rounded-xl font-inter  text-base shadow transition-all w-[220px] text-left">
              Research visa requirements
            </button>
            <button className="bg-gradient-to-b from-[#0B2F9F] to-[#3F6AEF] text-white px-6 py-5 rounded-xl font-inter  text-base shadow transition-all w-[220px] text-left">
              Complete the visa application form
            </button>
            <button className="bg-gradient-to-b from-[#0B2F9F] to-[#3F6AEF] text-white px-6 py-5 rounded-xl font-inter  text-base shadow transition-all w-[220px] text-left">
              Schedule an appointment
            </button>
          </div>
        </div>
      </div>

      {/* Visa Form */}
      <form className="bg-[#F8FAFF] rounded-[20px] shadow p-8 space-y-8 border border-primary/30">
        {/* Client Details */}
        <div>
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-sora font-bold text-[28px] text-black leading-tight">
              Client Details
            </h3>
            <FaClipboardList className="w-5 h-5 text-primary" />
          </div>
          <hr className="border-t-1 border-[#030303] mb-4 w-1/3" />
          <div className="grid grid-cols-4 gap-4">
            <div className="col-span-1">
              <div className="flex items-center gap-2">
                <span className="text-primary text-xl font-bold">*</span>
                <select className="rounded-xl border-none shadow-md px-4 py-3 bg-white text-base font-sans text-[#585858] w-full focus:ring-2 focus:ring-primary">
                  <option>Mr</option>
                  <option>Ms</option>
                  <option>Mrs</option>
                  <option>Dr</option>
                </select>
              </div>
            </div>
            <div className="col-span-1">
              <div className="flex items-center gap-2">
                <span className="text-primary text-xl font-bold">*</span>
                <input
                  type="text"
                  placeholder="First Name"
                  required
                  className="rounded-xl border-none shadow-md px-4 py-3 bg-white text-base font-sans text-[#585858] w-full focus:ring-2 focus:ring-primary"
                />
              </div>
            </div>
            <div className="col-span-2">
              <div className="flex items-center gap-2">
                <span className="text-primary text-xl font-bold">*</span>
                <input
                  type="text"
                  placeholder="Last Name"
                  required
                  className="rounded-xl border-none shadow-md px-4 py-3 bg-white text-base font-sans text-[#585858] w-full focus:ring-2 focus:ring-primary"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Contact Details */}
        <div>
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-sora font-bold text-[28px] text-black leading-tight">
              Contact Details
            </h3>
            <FaClipboardList className="w-5 h-5 text-primary" />
          </div>
          <hr className="border-t-1 border-[#030303] mb-4 w-1/3" />
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <span className="text-primary text-xl font-bold">*</span>
              <input
                type="tel"
                placeholder="Phone Number"
                required
                className="rounded-xl border-none shadow-md px-4 py-3 bg-white text-base font-sans text-[#585858] w-full focus:ring-2 focus:ring-primary"
              />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-primary text-xl font-bold">*</span>
              <input
                type="email"
                placeholder="Email"
                required
                className="rounded-xl border-none shadow-md px-4 py-3 bg-white text-base font-sans text-[#585858] w-full focus:ring-2 focus:ring-primary"
              />
            </div>
          </div>
        </div>

        {/* Upload Documents */}
        <div>
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-sora font-bold text-[28px] text-black leading-tight">
              Upload Documents
            </h3>
            <FaClipboardList className="w-5 h-5 text-primary" />
          </div>
          <hr className="border-t-1 border-[#030303] mb-4 w-1/3" />
          <div className="flex gap-4">
            {/* Upload Photo */}
            <div
              className="flex-1 border-2 border-dashed border-[#0B2F9F] rounded-xl flex flex-col items-center justify-center py-8 cursor-pointer bg-[#EAF0FF] hover:bg-[#e0eaff] transition"
              onClick={() => photoInputRef.current?.click()}
            >
              <input
                type="file"
                accept="image/*"
                ref={photoInputRef}
                className="hidden"
              />
              <div className="flex flex-col items-center gap-2">
                <span className="font-sora font-semibold text-lg text-black">
                  Upload Photo
                </span>
                <img src={imageupload} alt="" className="w-8 h-8" />
              </div>
            </div>
            {/* Upload Passport */}
            <div
              className="flex-1 border-2 border-dashed border-[#0B2F9F] rounded-xl flex flex-col items-center justify-center py-8 cursor-pointer bg-[#EAF0FF] hover:bg-[#e0eaff] transition"
              onClick={() => passportInputRef.current?.click()}
            >
              <input
                type="file"
                accept="application/pdf,image/*"
                ref={passportInputRef}
                className="hidden"
              />
              <div className="flex flex-col items-center gap-2">
                <span className="font-sora font-semibold text-lg text-black">
                  Upload Copy of Passport
                </span>
                <img src={imageupload} alt="" className="w-8 h-8" />
              </div>
            </div>
          </div>
        </div>

        {/* Terms & Submit */}
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-center gap-3">
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <span className="text-[#585858] font-sans text-base">
              Agree To Terms & Conditions
            </span>
          </div>
          <button
            type="submit"
            disabled={!agreed}
            className="bg-primary hover:bg-[#0B2F9F]/90 text-white px-10 py-3 rounded-xl font-semibold font-sans text-base shadow disabled:opacity-60 disabled:cursor-not-allowed"
          >
            Submit Documents
          </button>
        </div>
      </form>
    </section>
  );
};

export default VisaAssistance;
